import ls from "utils/secureStorage";
import configs from "config";
import { Button, ButtonProps } from "@chakra-ui/react";

export interface Props extends ButtonProps {}

const CloseWindow = (props: Props) => {
  const handleClose = () => {
    const URL = ls.get(configs.PERSIST_URL);
    window.location.replace(`/${URL}`);
  };

  return (
    <div>
      <Button
        minW="160px"
        w="fit-content"
        mt={{ base: "10px !important", md: "20px !important" }}
        variant="transparent"
        fontWeight="500"
        textDecoration="underline"
        onClick={handleClose}
        p="0"
        h={{ base: "20px", md: "auto" }}
        minH={{ base: "20px", md: "30px" }}
        {...props}
      >
        Close
      </Button>
    </div>
  );
};

export default CloseWindow;
